import {useDocument} from '../../firebase/hooks/useDocument';
import {Collection, PublicProfileDocument} from '../PublicProfileDocument';
import {PublicProfile} from '#common/users/types';

export function useUserPublicProfile(id: string): PublicProfileDocument {
  return useDocument<PublicProfile>(Collection, id);
}
